import TheGrid from '@/views/campaigns/inpar/results/grid'

export default {
  path: '/campaigns/inpar/results',
  redirect: '/campaigns/inpar/results/index',
  name: 'inparResults',
  meta: {
    auth: {
      redirect: {
        name: 'inparResults.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Resultados DSR'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'inparResults.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
